import { useEffect } from 'react';

/**
 * Sets document title and meta tags dynamically per page.
 * Returns cleanup on unmount only for title; meta tags are upserted and left.
 */
export function useSEO({ title, description, keywords, canonical, image, type = 'website', noindex = false } = {}) {
  useEffect(() => {
    const fullTitle = title ? `LIFELINKE · ${title}` : 'LIFELINKE - Piattaforma di Emergenza in Tempo Reale';
    document.title = fullTitle;

    const upsertMeta = (attr, key, content) => {
      if (content === undefined || content === null) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const upsertLink = (rel, href) => {
      if (!href) return;
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    if (description) {
      upsertMeta('name', 'description', description);
      upsertMeta('property', 'og:description', description);
      upsertMeta('name', 'twitter:description', description);
    }
    if (keywords) upsertMeta('name', 'keywords', keywords);

    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('property', 'og:type', type);

    if (image) {
      upsertMeta('property', 'og:image', image);
      upsertMeta('name', 'twitter:image', image);
    }

    const url = canonical || (typeof window !== 'undefined' ? window.location.origin + window.location.pathname : null);
    if (url) {
      upsertLink('canonical', url);
      upsertMeta('property', 'og:url', url);
      upsertMeta('name', 'twitter:url', url);
    }

    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
  }, [title, description, keywords, canonical, image, type, noindex]);
}

export default useSEO;
